var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseButton1',{class:{'is-loading': _vm.isLoading},attrs:{"disabled":_vm.isLocked || _vm.leftTime>0},on:{"click":_vm.commit}},[_vm._v(_vm._s(_vm.buttonText))])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63601fc2","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/button/SendVerifyCodeButton.vue
// module id = null
// module chunks = 